import "./FooterModal.scss";

const FooterModal = () => {
  return (
    <div className="FooterModal-container">
      <h4 className="FooterModal-title">当サイトについて</h4>
      <div className="FooterModal-caption">
        <p>当サイトはChurch橋本が管理・運営しております。</p>
        <p>当サイトの利用にあたっては下記内容をお読みいただき</p>
        <p> これらに同意された場合のみご利用ください。</p>
        <p>なお、予告なしに内容変更する事がありますので、ご了承ください。</p>
      </div>
      <div className="FooterModal-item">
        <h4 className="FooterModal-item-title">免責事項</h4>
        <p>
          当サイトに掲載された情報またはご利用することで生じた
        </p>
        <p>いかなるトラブル、損失及び損害に対して</p>
        <p>当サイトは一切責任を負いません。</p>
      </div>
      <div className="FooterModal-item">
        <h4 className="FooterModal-item-title">リンクについて</h4>
        <p>当サイトのリンクは、原則としてフリーです。</p>
      </div>
      <div className="FooterModal-item">
        <h4 className="FooterModal-item-title">著作権・商標等について</h4>
        <p> 当サイトに掲載された全てのコンテンツは</p>
        <p> 音源等はChurch橋本</p>
        <p> イベントフライヤーは関係者の著作権、特許権、商標権その他の</p>
        <p> 権利により保護されています。</p>
        <p> これらコンテンツの複製、転用、改変は固くお断りいたします。</p>
        <p> また、音源の紹介や編曲等のご希望は</p>
        <p> お問い合わせ頂きますようお願い致します。</p>
      </div>
      <div className="FooterModal-item">
        <p> その他、不明点ございましたら</p>
        <p>
          <a href="#Contact">コンタクトフォーム</a>
          よりお問い合わせをお願い致します。
        </p>
        <p className="FooterModal-credit">2022.09.19 Church橋本</p>
      </div>
    </div>
  );
};

export default FooterModal;
